
import React from 'react';
import { colors } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import EditNoteIcon from '@mui/icons-material/EditNote';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import CellTowerIcon from '@mui/icons-material/CellTower';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import HiveIcon from '@mui/icons-material/Hive';
import { Label } from 'components';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS','Client'],
				// projects: ['VMO2 Dashboards','VMO2 Ran'],
			},
		],
	},
	{
		title: 'Menu',
		pages: [
			/* {
				title: 'S12 KPI Supervision',
				href: '/S12KPISupervision',
				icon: DashboardIcon,
				roles: ['Administrator'],
				projects: ['VMO2 Dashboards'],
				children: [
					{
						title: 'VFinTF - Performance',
						href: '/S12KPISupervision/VFinTFPerformance',
					},
					{
						title: 'TFinVF - Performance',
						href: '/S12KPISupervision/TFinVFPerformance',
					},
					{
						title: 'TFinTF - Performance',
						href: '/S12KPISupervision/TFinTFPerformance',
					},
					{
						title: 'Warnings',
						href: '/S12KPISupervision/Warnings',
					},
					{
						title: 'VFinTF - Detector',
						href: '/S12KPISupervision/VFinTFDetector',
					},
					{
						title: 'TFinVF - Detector',
						href: '/S12KPISupervision/TFinVFDetector',
					},
					{
						title: 'Cell Trend Detector',
						href: '/S12KPISupervision/CellTrendDetector',
					},
					{
						title: 'Monthly Blended without Exclusions',
						href: '/S12KPISupervision/MonthlyBlendedWithoutExclusions',
					},
					{
						title: 'Step-in Monitoring',
						// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS','Client'],
						// projects: ['VMO2 Dashboards'],
						children: [
							{
								title: 'Performance Follow-up',
								href: '/S12KPISupervision/PerformanceFollowUp',
							},
							{
								title: 'Timeline',
								href: '/S12KPISupervision/Timeline',
							}
						],
					},
					{
						title: 'Performance Overview',
						// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS','Client'],
						// projects: ['VMO2 Dashboards'],
						children: [
							{
								title: 'Performance Forecast',
								href: '/S12KPISupervision/PerformanceForecast',
							},
							{
								title: 'Performance Breakdown',
								href: '/S12KPISupervision/PerformanceBreakdown',
							}
						],
					}
				],
			}, */
			{
				title: 'Performance',
				href: '/Performance',
				icon: TroubleshootIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Blended',
				href: '/Blended',
				icon: CalendarViewMonthIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				children: [
					{
						title: 'Monthly Blended',
						children: [
							{
								title: 'Pack 1',
								href: '/Blended/MonthlyBlended1',
							},
							{
								title: 'Pack 2',
								href: '/Blended/MonthlyBlended2',
							}
						]
					},
					{
						title: 'Weekly Blended',
						href: '/Blended/WeeklyBlended',
					}
				],
			},
			{
				title: 'Estimate Customer Experience',
				href: '/EstimateCustomerExperience',
				icon: TravelExploreIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Network Faults',
				href: '/NetworkFaultsDetector',
				icon: CellTowerIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: '5G',
						href: '/NetworkFaultsDetector/5G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: '4G',
						href: '/NetworkFaultsDetector/4G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
				]
			},
			{
				title: 'Demand KPIs View',
				href: '/DemandKPIsView',
				icon: AppRegistrationIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Cluster KPIs View',
				href: '/Cluster',
				icon: HiveIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: 'Management',
						href: '/Cluster/Management',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: 'Demand KPIs View',
						href: '/Cluster/DemandKPIsView',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
				]
			},
			{
				title: 'Step In',
				href: '/StepIn',
				icon: EditNoteIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: 'Management',
						href: '/StepIn/Management',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS']
					},
					{
						title: 'Timeline',
						href: '/StepIn/Timeline',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
				]
			},
			{
				title: '3GSD',
				href: '/Shutdown3g',
				icon: CellTowerIcon,
				projects: ['3GSD'],
				children: [
					{
						title: 'Cluster KPI',
						href: '/Shutdown3g/ClusterKpi',
						children: [
							{
								title: 'Hourly',
								href: '/Shutdown3g/ClusterKpi/Hourly',
							},
							{
								title: 'Daily',
								href: '/Shutdown3g/ClusterKpi/Daily',
							}
						]
					},
					{
						title: 'Cell KPI',
						href: '/Shutdown3g/CellKpi',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						children: [
							{
								title: 'Hourly',
								href: '/Shutdown3g/CellKpi/Hourly',
								children: [
									{
										title: '2G',
										href: '/Shutdown3g/CellKpi/Hourly/2G',
									},
									{
										title: '3G',
										href: '/Shutdown3g/CellKpi/Hourly/3G',
									},
									{
										title: '4G',
										href: '/Shutdown3g/CellKpi/Hourly/4G',
									}
								]
							},
							{
								title: 'Daily',
								href: '/Shutdown3g/CellKpi/Daily',
								children: [
									{
										title: '2G',
										href: '/Shutdown3g/CellKpi/Daily/2G',
									},
									{
										title: '3G',
										href: '/Shutdown3g/CellKpi/Daily/3G',
									},
									{
										title: '4G',
										href: '/Shutdown3g/CellKpi/Daily/4G',
									}
								]
							}
						]
					},
					// {
					// 	title: 'Cluster KPI',
					// 	href: '/Shutdown3g/ClusterKPI',
					// 	roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					// },
					{
						title: 'Outliers',
						href: '/Shutdown3g/Outliers',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: 'Data Integrity',
						href: '/Shutdown3g/DataIntegrity',
						roles: ['Administrator', 'Manager', 'CelfinetHQ']
					},
					// {
					// 	title: 'Outliers',
					// 	href: '/Shutdown3g/Outliers',
					// 	roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					// },
					// {
					// 	title: 'TopOffenders',
					// 	href: '/Shutdown3g/TopOffenders',
					// 	roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					// }
				]
			},
			{
				title: 'Radio Design',
				href: '/RadioDesign',
				icon: DashboardIcon,
				projects: ['VMO2 Radio Design'],
				children: [
					{
						title: 'Traffic Trends',
						href: '/RadioDesign/TrafficTrends',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: 'Activities Tracker',
						href: '/RadioDesign/ActivitiesTracker',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS']
					},
					{
						title: 'Activities Map',
						href: '/RadioDesign/ActivitiesMap',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS']
					}
				]
			},
			{
				title: 'Data Management',
				href: '/DataManagement',
				icon: BrowserUpdatedIcon,
				projects: ['VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			}
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
			{
				title: 'Data Integrity',
				href: '/management/dataIntegrity',
				roles: ['Administrator', 'Manager'],
				icon: QueryStatsIcon
			},
			/* 			{
				title: 'Statistics',
				href: '/management/statistics',
				roles: ['Administrator', 'Manager'],
				icon: SsidChartIcon
			}, */
			{
				title: 'Analytics Dashboard',
				href: '/management/AnalyticsDashboard',
				roles: ['Administrator', 'Manager'],
				icon: SsidChartIcon
			}
		],
	}
];
